<template>
  <div class="">
    <div class="row justify-content-end">
      <div class="col-auto">
        <button @click="refresh()" class="btn  btn-secondary">
          <i class="bi bi-arrow-clockwise"></i>
          Actualiser
        </button>
      </div>

      <div class="col-auto">
        <button
          @click="$router.push({ name: 'items-create' })"
          class="btn btn-primary"
        >
          <i class="bi bi-plus-square"></i>
          Créer un nouveau produit
        </button>
      </div>

      <div class="col-auto">
        <button @click="printAll()" class="btn btn-secondary">
          <i class="bi bi-printer"></i>
          Imprimer
        </button>
      </div>
    </div>
    <br />

    <vue-data-table 
      :headers="headers" 
      :data="items" 
      :items-per-page="10" 
      :buttons="buttons"
      :summable-columns="summableColumns"
    />
   
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      search_value: "",
      addedToday: false,
      sortValue: "",
      headers: [
        { field: 'reference', label: 'Référence',class:'' },
        { field: 'fullName', label: 'Désignation',class:'' },
        { field: 'measuring', label: 'Unité', class: '' },
        { field: 'priceTTC', label: 'Prix TTC',class:'' },
      ],
      buttons: [
        {
          label: 'Edit',
          icon: 'bi bi-pencil-square',
          class: 'btn',
          visible: () => this.$userRole === 'Admin',
          action: (item) => {
            this.$router.push({
              name: 'items-edit',
              params: { reference: item.reference },
            });
          },
        },
        {
          label: 'Details',
          icon: 'bi bi-list-ul text-primary',
          class: 'btn',
          action: (item) => {
            this.$router.push({
              name: 'items-details',
              params: { reference: item.reference },
            });
          },
        },
        {
          label: 'Delete',
          icon: 'bi bi-trash text-danger',
          class: 'btn',
          visible: () => this.$userRole === 'Admin',
          action: (item) => {
            this.remove(item);
          },
        }
      ],
      summableColumns: [
        
      ],
    };
  },
  computed: {
    ...mapGetters("item", {
      items: "getItems",
    }),
    // imageUrl() {
    //   return (item) => `${item.image}`
    // },
  },
  mounted() {
    this.$store.dispatch("item/getAll");
  },
  methods: {
    async search(value) {
      return await this.$store.commit("item/search", value);
    },
    async refresh() {
      return await this.$store.dispatch("item/getAll");
    },

    async sort(value) {
      return await this.$store.commit("item/sort", value);
    },

    async remove(data) {
      let item = data;
      await this.$confirm({
        message: "Vous voulez supprimer l'article  " + item.fullName,
        button: {
          no: "Non",
          yes: "Oui",
        },

        callback: (confirm) => {
          if (confirm) {
            this.$store.dispatch("item/destroy", item.reference);
          }
        },
      });
    },

    async printAll() {
      return await this.$store.dispatch("item/printAll");
    },
  },
};
</script>
